import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function SubmissionCardSkeleton({ hideElement }: { hideElement?: boolean }) {
  const today = new Date();
  const activationDate = new Date('2024-06-17');
  return (
    <div className='bg-white w-full shadow-md relative rounded-lg p-3 text-left'>
      <div className='text-center'>
        <Skeleton className='w-[85px] h-[85px]' />
        <Skeleton className='w-28 h-7 mt-3' />
        <Skeleton className=' w-28 h-7 mt-3' />
        {/* <div className={`${!hideElement ? 'hidden' : ''}`}>
          {'hello'}
          <Skeleton className='w-28 h-7 mt-3' />
        </div> */}
      </div>
      <div className={`${hideElement || today < activationDate ? 'hidden' : ''}`}>
        <Skeleton className='w-full h-11 mt-3' />
        <Skeleton className='w-full h-11 mt-3' />
      </div>
    </div>
  );
}
